export enum API {
  COPY = '/api/copy/',
  MANY_PARAGRAPHS = '/api/copy/many-paragraphs/',
  ASK_AI = '/api/ask-ai/',
  INITIAL_EVALUATION = '/api/initial-evaluation/',
  AI_COPY = '/api/ai-copy/',
}
